import { render, staticRenderFns } from "./logictype.vue?vue&type=template&id=45371657&"
import script from "./logictype.vue?vue&type=script&lang=js&"
export * from "./logictype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports